const STORAGE_KEY = "WES_CATEGORY_DATA";

const VERSION = process.env.REACT_APP_CATEGORY_CACHE_VERSION || "1";

const DEFAULT_TTL_MINUTES = 60;
const configuredTtl = Number(process.env.REACT_APP_CATEGORY_CACHE_TTL_MIN);
const TTL_MS =
  (Number.isFinite(configuredTtl) && configuredTtl > 0 ? configuredTtl : DEFAULT_TTL_MINUTES) * 60 * 1000;

export const readCategoryCache = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const cached = JSON.parse(raw);
    if (!cached || cached.version !== VERSION) return null;
    if (!Number.isFinite(cached.storedAt) || Date.now() - cached.storedAt > TTL_MS) return null;

    return cached.data ?? null;
  } catch {
    return null;
  }
};

export const writeCategoryCache = (data) => {
  if (!data) return;
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ version: VERSION, storedAt: Date.now(), data }),
    );
  } catch {
    return;
  }
};

export const clearCategoryCache = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
};
